const isDesigner = (user) => {
  return user && user['https://www.wabweb.com/app_metadata.role']?.includes('designer')
}

export {
  isDesigner
}